<template>
    <div class="menu-item">
        <div class="image-container">
            <img :src="menuItem.imagen" alt="menu image" class="menu-image" />
        </div>
        <div class="menu-info">
            <h3 class="menu-title">{{ menuItem.name }}</h3>
            <p class="menu-description">{{ menuItem.description }}</p>
            <p class="menu-price">{{ menuItem.price.toFixed(2) | formatear_precio }}</p>
        </div>
        <div class="menu-actions">
            <div class="quantity-controls" v-if="stockRestante > 0">
                <button class="quantity-btn decrease" @click="adjustQuantity(-1)" :disabled="quantity <= 1">−</button>
                <span class="quantity">{{ quantity }}</span>
                <button 
                    class="quantity-btn increase" 
                    @click="adjustQuantity(1)"
                    :disabled="quantity >= stockRestante || quantity >= MaxCantidad"
                >
                    +
                </button>
            </div>
            <button 
                v-if="stockRestante > 0" 
                @click="handleAddToCart" 
                class="add-to-cart-btn"
                :class="{ animated: animadoBoton, disabled: isButtonDisabled }"
            >
                {{ $t('productos.añadir') }}
            </button>
            <button v-else class="add-to-cart-btn disabled">
                {{ $t('productos.agotado') }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            menuItem: {
                type: Object,
                required: true,
            },
            addToCart: {
                type: Function,
                required: true,
            },
            desactivar: {
                type: Boolean,
                required: true,
            },
            productos: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                quantity: 1,
                animadoBoton: false,
                isButtonDisabled: false,
                MaxCantidad: 15
            };
        },
        computed: {
            stockRestante() {
                const carritoProducto = this.productos.find(
                    producto => producto.item.id === this.menuItem.id
                );
                const cantidadEnCarrito = carritoProducto ? carritoProducto.units : 0;
                return this.menuItem.stock - cantidadEnCarrito;
            },
        },
        methods: {
            handleAddToCart() {
                if (this.quantity <= this.stockRestante && !this.isButtonDisabled) {
                    this.addToCart({ item: this.menuItem, units: this.quantity });
                    this.quantity = 1;
                    this.animadoBoton = true;
                    this.isButtonDisabled = true;
                    setTimeout(() => {
                        this.animadoBoton = false;
                        this.isButtonDisabled = false;
                    }, 1000);
                    this.$toast.success('Producto añadido correctamente');
                }
            },
            adjustQuantity(value) {
                const newQuantity = this.quantity + value;
                if (newQuantity <= this.stockRestante && newQuantity >= 1) {
                    this.quantity = newQuantity;
                }
            },
        },
    };
</script>

<style scoped>
.menu-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
    justify-content: center;
}

.menu-item {
    background: #000000;
    border-radius: 16px;
    overflow: hidden;
    text-align: center;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 300px;
    width: 100%;
}

.menu-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
}

.image-container {
    position: relative;
    width: 100%;
    padding-top: 75%;
    overflow: hidden;
    background: #222;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.menu-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
}


.menu-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
}

.image-container:hover .menu-image {
    transform: scale(1.1);
}

.menu-info {
    background: #000000;
    text-align: left;
    padding: 16px;
    padding-bottom: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.menu-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #ffffff;
}

.menu-description {
    font-size: 14px;
    color: #b3b3b3;
    margin-bottom: 12px;
    line-height: 1.6;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
}


.menu-price {
    font-size: 21px;
    font-weight: bold;
    color: #ffffff;
    margin-top: auto;
}

/* Acciones */
.menu-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-top: 1px solid #333333;
}

.quantity-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 10px;
}

.quantity-btn {
    background: #333;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 18px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.quantity-btn:hover:not(:disabled) {
    background: #555;
}

.quantity-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.quantity {
    font-size: 16px;
    font-weight: bold;
    color: white;
}

.add-to-cart-btn {
    flex-grow: 1;
    background: var(--altcolor);
    color: white;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 16px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    transition: background 0.3s ease, transform 0.2s ease;
}

.add-to-cart-btn:hover:not(.disabled) {
    background: var(--altcolor);
    filter: brightness(85%);
    transform: translateY(-2px);
}

.add-to-cart-btn.disabled {
    background: #ccc;
    cursor: not-allowed;
    color: #000000
}

/* Responsivo */
@media (max-width: 768px) {
    .menu-container {
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    }

    .menu-item {
        max-width: 100%;
        min-height: 350px;
    }

    .menu-title {
        font-size: 18px;
    }

    .menu-description {
        font-size: 12px;
        -webkit-line-clamp: 2;
    }

    .menu-price {
        font-size: 19px;
    }

    .add-to-cart-btn {
        font-size: 14px;
        padding: 10px;
    }
}
</style>
